const API_URL = process.env.REACT_APP_API_URL || 'https://api.mintbridge.cloud';

let authToken = null;

export function setToken(token) {
  authToken = token;
}

export function clearToken() {
  authToken = null;
}

export async function apiCall(endpoint, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }

  return response.json();
}

// Auth endpoints
export const auth = {
  signup: (data) => apiCall('/api/auth/signup', { method: 'POST', body: JSON.stringify(data) }),
  login: (data) => apiCall('/api/auth/login', { method: 'POST', body: JSON.stringify(data) }),
  me: () => apiCall('/api/auth/me'),
};

// Merchant onboarding
export const onboarding = {
  submit: (data) => apiCall('/api/merchant/onboarding', { method: 'POST', body: JSON.stringify(data) }),
};

// Dashboard data
export const merchant = {
  stats: () => apiCall('/api/merchant/stats'),
  payments: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiCall(`/api/merchant/payments${query ? `?${query}` : ''}`);
  },
  escrow: () => apiCall('/api/merchant/escrow'),
  chargebacks: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiCall(`/api/merchant/chargebacks${query ? `?${query}` : ''}`);
  },
  settings: () => apiCall('/api/merchant/settings'),
};
